// extracted by css-extract-rspack-plugin
export default {"modalConfirmBox":"modalConfirmBox___nzVzT","warnTitleMsg":"warnTitleMsg___1NbVL","footBotton":"footBotton___wLwyV"};